import React from 'react';
import { Box, Typography } from '@mui/material';

interface RangeLabeledProps {
  label: string;
  from?: React.ReactNode;
  to?: React.ReactNode;
}

export function RangeLabeled({ label, from, to }: RangeLabeledProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Typography variant="caption" color="text.secondary">{label}</Typography>
      <Typography variant="body2" color="text.primary" sx={{ wordBreak: 'break-word' }}>
        {from ? `${from}` : '-'}{(from || to) ? ' ' : ''}{to ? `- ${to}` : ''}
      </Typography>
    </Box>
  );
}
